import React, {Fragment} from "react";
import {connect} from 'react-redux';
import {bindActionCreators} from "redux";
import _ from "lodash";
import {createRoom} from "../../../../../creators/room";
import {createRoomMessage} from "../../../../../creators/room.message";
// import {fetchUserFriends} from "../../../../../creators/user.friends";

// import {Button} from "../../../../components/Button";

import {Can} from "../../../../../ability-context";
// import CtaCannot from "../../../../components/CtaCannot";
import RoomSendMessageMedias from "../RoomSendMessageMedias/RoomSendMessageMedias";
// import RoomSendMessageText from "../RoomSendMessageText/RoomSendMessageText";
import Alert from "../../../../components/Alert";
import Modal from "../../../../components/Modal";
import ChatEditorLexical from "../ChatEditorLexical/ChatEditorLexical";



class RoomSendMessage extends React.Component {
    constructor(props) {
        super(props);
        this.sendMessageMediaRef = React.createRef();
        this.state = {
            toggleShareMedia: false,
            error: null,
            toggleAlert : false
        };
        this.handleSubmitMessage = this.handleSubmitMessage.bind(this);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.roomMessages !== this.props.roomMessages && !this.props.currentRoom._id && typeof (this.props.handleRoom) === "function") {
            this.props.handleRoom(this.props.room);
        }
    }

    handleSubmitMessage(contentState){
        if(!this.state.toggleAlert && _.get(this.sendMessageMediaRef,"state.multipleRawFiles") && this.sendMessageMediaRef.state.multipleRawFiles.length && this.sendMessageMediaRef.state.toggleMedia){
            this.setState({toggleAlert : true});
        }
        else{
            setTimeout(()=>{
                this.handleSubmitMessageText(contentState);
            },50);
            this.setState({toggleAlert : false});
        }
    }

    handleSubmitMessageText(contentState) {
        let data = {
            ...contentState,
            kind: "text"
        };
        if (this.props.isCreate) {
            let users = this.props.users.map(item => {
                return item._id
            });
            if (users.length >= 1) {
                this.props.createRoom({...data, users});
            }
        }
        else {
            this.props.createRoomMessage(this.props.currentRoom._id, data);
        }
    }

    getMentionsFromUsers(users = []){
        return users.map(user=>({
            avatar : user.profile.avatar,
            username : user.username,
            _id : user._id
        }))
    }

    render() {
        return (
            <Fragment>
                {this.state.error && !this.props.currentRoom._id && (<div className={"warning mx-8"}>{this.state.error}</div>)}
                <Modal toggle={this.state.toggleAlert}
                       handleClose={() => this.setState({toggleAlert: false})}>
                    <Alert text="Souhaitez vous envoyer qu'une partie de vos medias ?" handleDelete={this.handleSubmitMessage}
                           handleClose={() => this.setState({toggleAlert: false})}/>
                </Modal>
                <div className="messenger-send-message">
                    <div className={"row message-options-wrapper"}>
                        {!this.props.isCreate && (
                            <RoomSendMessageMedias
                                handleToogleUpload={this.props.handleToogleUpload}
                                roomId={this.props.currentRoom._id}
                                onRef={ref => (this.sendMessageMediaRef = ref)}
                            />
                        )}
                    </div>
                    <div className="message-container row align-center px-8">
                        <Can action="create" subject={"RoomMessage"} passThrough>
                            {can=>(
                                <ChatEditorLexical
                                    mentions={this.getMentionsFromUsers(this.props.users || this.props.currentRoom.participantsWithoutCurrent)}
                                    onSubmit={(data)=>can && this.handleSubmitMessage(data)}
                                />
                            )}
                        </Can>

                    </div>
                </div>
            </Fragment>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        // currentUserId: state.currentUser.data && state.currentUser.data._id,
        // currentUserLoading: state.currentUser.loading,
        // currentUserInitialized: state.currentUser.initialized,
        //
        // userFriends: state.userFriends.data,
        // userFriendsLoading: state.userFriends.loading,
    }
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
    createRoomMessage,
    createRoom,
    // fetchUserFriends,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(RoomSendMessage);
